module.exports = __webpack_public_path__ + "static/media/RicardoLH2.02d23400.pdf";